<script setup lang="ts">
import { FormField, FormItem, FormLabel, FormMessage, FormControl } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { vAutoAnimate } from '@formkit/auto-animate/vue';
import { cn } from '@/lib/utils';
import { items as itemsData } from '@/components/reason/reasonFormData';

const props = defineProps<{
    items: typeof itemsData;
}>();
</script>

<template>
    <FormField name="items">
        <FormItem v-auto-animate class="space-y-2.5">
            <span class="text-md font-bold">Choose your visit reason:</span>
            <FormField v-for="item in props.items" v-slot="{ value, handleChange, errors }" :key="item.id" type="checkbox"
                :value="item.name" :unchecked-value="false" name="items">
                <FormItem
                    class="flex flex-row items-center space-x-3 space-y-0 px-3.5 bg-white rounded-xl ring-1 ring-gray-300 cursor-pointer select-none"
                    :class="{'ring-2 ring-primary': value.includes(item.name)}">
                    <FormControl>
                        <Checkbox :checked="value.includes(item.name)" @update:checked="handleChange"
                            class="border-gray-600 h-6 w-6" />
                    </FormControl>
                    <FormLabel
                        :class="cn('font-normal cursor-pointer w-full py-5', {'font-bold': value.includes(item.name), 'text-inherit': errors?.length > 0})">
                        {{ item.label }}
                    </FormLabel>
                </FormItem>
            </FormField>
            <FormMessage />
        </FormItem>
    </FormField>
</template>
